import styled from "styled-components";
import { theme } from "@themes";

const backgroundColor = {
  "blue-card": theme.primary.bluePale,
  "blue-card-3": theme.primary.bluePale,
  "yellow-card": theme.primary.yellowPale,
  "red-card": theme.primary.redPale,
};

const fontColor = {
  "blue-card": theme.primary.blueDark,
  "blue-card-3": theme.primary.blueDark,
  "yellow-card": theme.primary.yellowDark,
  "red-card": theme.primary.yellowDark,
};

const borderColor = {
  "blue-card": theme.primary.indigo,
  "blue-card-3": theme.primary.indigo,
  "yellow-card": theme.primary.orangeDeep,
  "red-card": theme.primary.redDarkBrand,
};

export const NotificationContent = styled.div`
  cursor: pointer;
  transition: all ease 0.3s;
  &:hover {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
`;

export const UserNoticeContainer = styled.div`
  width: 100%;
  height: fit-content;
  color: ${({ classIdentity }) => fontColor[classIdentity]};
  border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[400]};
  padding: 10px 36px;
`;

export const HeaderContainer = styled.p`
  font-size: 16px;
  font-weight: 800;
  color: ${({ theme }) => theme.neutral.gray[3200]};
  margin-bottom: 8px;
`;

export const ContentContainer = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.neutral.gray[3200]};
  p {
    margin-bottom: 0px;
    text-align: justify;
  }
`;
